var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div"},[_c('iframe',{attrs:{"src":"/v2/index.html","frameborder":"0"}})])
}]

export { render, staticRenderFns }